<template>
  <div class="sakura-lottery">
    <!-- 活动标题 -->
    <div v-wechat-title='"梦境携行-组队得百抽奖励"'></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-sakura' v-show='preloadingShow'></div>
    </transition>

    <header :class="'header-login-' + headerLogin">
      <div class="acco">{{ isUserInfo.account }}</div>
      <a class="download-btn" href="javascript:;" title="下载按钮" @click="loggerCount('小樱_百抽H5_点击下载按钮')"></a>
      <a v-if="isUserInfo.account == ''" class="logon-btn" @click="logon()" title="登录&切换按钮" href="javascript:;"></a>
      <a v-else href="javascript:;" class="switch-btn" @click="switchBtn()"></a>
    </header>

    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin'
      v-on:channelCallback='selectCallback'
      :gameName="gameName"
      :downloadUrl="downloadUrl"
      :loginTypes="loginTypes"
      :autoOpenOS="false"
      channelTips="角色ID可在游戏中—信息查看"></Login>
    <Os v-if='isShowOs'
      v-on:selectCallback='selectCallback'
      v-on:logoutCallback='osCancell'
      :gameName="gameName"></Os>

    <MySwiper :noSwiperClass='noSwiperClass' ref="mySwiper">
      <template v-slot:first-slide-content>
        <div class='home-page-bc'>
          <div class="title">
            <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOut" name="fade">
              <img v-show="titleShow" src="https://download4.qcplay.com/h5-images/assets/images/active/sakura/lottery/title_img.png"/>
            </transition>
          </div>
          <div :class="'act-btn monitor-btn act-btn-' + isActivity.is_join" @click="nextPage()" data-event="参加活动">
            <a href="javascript:;"></a>
          </div>
        </div>
      </template>
      <template v-slot:second-slide-content>
        <div class='content-page'>
          <div class='active-content'>
            <div class="team-up-main">
              <div class="big-star"></div>
              <div :class="'progress-info progress-info-' + isActivity.count"></div>
              <div class="friend-box" >
                <div :class="'friend-'+index+ ' tyle-'+item.nick_name" v-for="(item, index) in isActivity.team_data" :key="index" @click="addFriends(item.nick_name)"><b>入梦者:{{ item.nick_name }}</b></div>
              </div>
              <div>
                <div v-if="isUserInfo.role_id == ''" :class="'bind-btn bind-btn-' + isActivity.count" @click="bindRole()"></div>
                <div v-else class="complete-bind-btn"></div>
              </div>              
            </div>
            <div class="reward-main">
              <div class="reward-title"></div>
              <div :class="'reward-box reward-show-' + isActivity.reward_list.length">
                <a class="bind-tips" href="javascript:;"></a>
              </div>
            </div>
            <div class="rule-main">
              <div class="rule-title"></div>
              <div class="rule-info"></div>
            </div>
          </div>
        </div>        
      </template>
    </MySwiper>

    <!-- 分享相关DOM -->
    <div class="share-box-lottery" ref="imageDom">
      <img src="https://download4.qcplay.com/h5-images/assets/images/active/sakura/lottery/share_pop.png"/>
      <div class="share-img">
        <div class="url-box">
          <p>{{ shareLink }}</p>
        </div>
        <div class="qrcode-box">
          <div id="qrcode" class="qrcode"></div>
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <!-- 是否确认创立搜索小队 -->
    <div class="establish-wrap popup_wrap" v-show="establishShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="establish-box popup_wrap-box" v-show="establishShow">
          <a class="close-btn" href="javascript:;" @click="establishShow = false"></a>
          <a class="determine-btn" href="javascript:;" @click="establishTeam()"></a>
        </div>
      </transition>
      <div class="close-bg" @click="establishShow = false"></div>
    </div>

    <!-- 成功加入小队 -->
    <div class="added-success-wrap popup_wrap" v-show="addedSuccessShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="added-success-box popup_wrap-box" v-show="addedSuccessShow">
          <a class="link-btn" href="javascript:;"></a>
        </div>
      </transition>
    </div>

    <!-- 成功创立小队 -->
    <div class="establish-success-wrap popup_wrap" v-show="establishSuccessShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="establish-success-box popup_wrap-box" v-show="establishSuccessShow">
          <a class="link-btn" href="javascript:;" @click="goNextPage()"></a>
        </div>
      </transition>
    </div>

    <!-- 注销弹窗 -->
    <div class="logout-wrap popup_wrap" v-show="logoutShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="logout-box popup_wrap-box" v-show="logoutShow">
          <p>是否退出当前账号</p>
          <a class="left-btn" href="javascript:;" @click="logoutShow = false">取消</a>
          <a class="right-btn" href="javascript:;" @click="logoutBtn()">确定</a>
        </div>
      </transition>
    </div>

    <!-- 分享弹窗 -->
    <div :class="'help-share-wrap popup_wrap help-share-wrap-' + shareShow">
      <div class="help-share-box popup_wrap-box">
        <div class="bottom-img">
          <div class="qrcode-box">
            <div id="qrcode2" class="qrcode"></div>
          </div>
        </div>          
        <img :src="shareImg" alt="分享图片" />
        <button class="monitor-btn" @click="onCopy()" id="clipboard-btn" data-event="复制邀请链接" :data-clipboard-text="clipInfo + shareLink"></button>
        <div class="close-bg" v-show="shareShow" @click="closeShare()"></div>
      </div>
    </div>

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>
</template>
<script>
import { Toast, Indicator } from 'mint-ui';
import Clipboard from 'clipboard';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import MySwiper from '@/components/MySwiper';
import { onGetInitDataAPI, onEstablishApi, onLogoutApi, onTeamBindApi } from '../api';
import { getTimeStamp, buriedLogger, getRandomString } from '@/utils/utils';
import { generateQRCode, generateCanvasImage } from '@/utils/share';

export default {
  name: 'lottery',
  components: {
    Header,
    Footer,
    Login,
    Os,
    MySwiper
  },

  data () {
    return {
      gameName: 'sakura',
      logger: null,
      downloadUrl: 'https://sakura.qingcijoy.com/',
      preloadingShow: true,
      titleShow: false,
      headerLogin: false,
      noSwiperClass: 'swiper-no-swiping', // swiper-no-swiping
      shareLink: '',
      shareImg: null,
      shareShow: false,
      establishShow: false,
      addedSuccessShow: false,
      establishSuccessShow: false,
      logoutShow: false,
      // 全屏遮罩
      preventShow: false,
      isActivity: {
        count: '',
        is_create: '',
        is_first: '',
        is_join: '',
        reward_list: '',
        user_id: 0,
        team_data: [
          {nick_name : 0},
          {nick_name : 0},
          {nick_name : 0}
        ],
      },
      isUserInfo: {
        account: '',
        game_id: '',
        role_id: '',
        role_name: '',
        server_id: '',
        server_name: '',
      },
      // 号码后4位id
      accountId: '',
      // 复制使用的文案
      clipInfo: '',
      // 其他数据
      loginTypes: ['sms', 'password'],
      // 进度数值
      progress: 1,
    };
  },
  created () {
    // 测试
    // setTimeout(() => {
    //   this.titleShow = true;
    //   this.preloadingShow = false;
    //   this.mySwiper();
    //   this.$refs.mySwiper.nextSwiper(1);
    // }, 100);
      
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();
    setTimeout(() => {
      this.mySwiper();
    }, 100);
    onGetInitDataAPI().then(response => {
      this.onInitDataCallback(response);
      this.titleShow = true;
      this.preloadingShow = false;
      this.onInitState(response)
    });
    // 埋点
    const bl = buriedLogger('sakura', '小樱_百抽H5活动');
    this.logger = bl
  },
  mounted () {
    this.$nextTick(() => {
      this.monitoringEquipment();
      var linkUrl = 'https://h5.qingcigame.com/sakura/lottery/enter';
      this.isSetShare(linkUrl);
    })
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler (newValue, oldValue) {
        console.log('newValue', newValue);
        console.log('oldValue', oldValue);
        if (!newValue.account) {
          // TAG: 注销的时候
        } else {
          // TAG: 初始登陆/切换角色的时候
          onGetInitDataAPI().then(response => {
            this.onInitState(response)
          });          
        }
      }
    }
  },
  methods: {
    monitoringEquipment () {
      if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) location.href = `https://h5.qingcigame.com/sakura/lottery/pc${getTimeStamp()}`
    },
    // 登录弹窗
    logon() {
      this.changeLoginPopup(true);
      this.logger.sum('小樱_百抽H5_点击头部登录按钮');
    },
    switchBtn() {
      this.logoutShow = true;
      this.logger.sum('小樱_百抽H5_点击头部切换录按钮');
    },
    onInitState(response) {
      const { code } = response || {}
      if (Number(code) === 200) {
        this.setActivity(response.data.activity);
        this.setUserinfo(response.data.user_info);
      }
      // 很抱歉，请先登录！
      if (Number(code) === 403) {
        this.changeLoginPopup(true);
      }
      this.onToast(response.message);
    },
    // 账号注销按钮
    logoutBtn() {
      onLogoutApi().then(response => {
        const { code } = response || {}
        if (Number(code) === 200) {
          onGetInitDataAPI().then(response => {
            this.onInitState(response)
          });
          this.clearData();
        }
      });
    },
    // 绑定角色
    bindRole() {
      if (this.isUserInfo.account === undefined || this.isUserInfo.account === '') {
        this.changeLoginPopup(true);
        return
      }
      this.changeOsPopup(true);
      this.logger.sum('小樱_百抽H5_点击前往绑定角色');   
    },
    // 活动内容
    setActivity(data) {
      this.isActivity = data;
      if(this.isActivity.count > 0) {
        this.$refs.mySwiper.nextSwiper(1);
        this.noSwiperClass = '';
      }
      this.headerLogin = true;
    },
    // 个人信息
    setUserinfo(data) {
      this.isUserInfo = data;
      this.accountId = this.isUserInfo.account.substr(-4);
    },
    // 是否加入好友
    addFriends(nick_name) {
      if (this.isUserInfo.account === undefined || this.isUserInfo.account === '') {
        this.changeLoginPopup(true);
        return
      }
      if(nick_name == 0) {
        Indicator.open();
        this.preventShow = true;
        setTimeout(() => {
          const { protocol, host } = window.location;
          this.clipInfo = '《魔卡少女樱：回忆钥匙》现已正式上线！' + this.accountId + '邀请你加入小队，一同探索梦境解锁百抽福利：';
          this.shareLink = `${protocol}//${host}/sakura/lottery/help${getRandomString()}?friend_id=`+ this.isActivity.user_id;
          this.initShareData();
          this.logger.sum('小樱_百抽H5_点击邀请入梦者圆形按钮');
        }, 10);        
      }
    },
    initShareData () {
      try {
        this.setShare({ link: this.shareLink });
        this.qrcode(this.shareLink);
        this.qrcode2(this.shareLink);
        this.$nextTick(() => {
          this.generateShareImage();
        });
        // 例如：获取好友助力信息等
      } catch (err) {
        // 错误信息
        console.log('err', err);
      }
    },
    // 成立小队
    establishTeam() {
      this.establishShow = false;
      onEstablishApi().then(response => {
        this.establishReturn(response);
      });
    },
    qrcode (link) {
      generateQRCode(document.getElementById('qrcode'), {
        text: link,
        colorDark: '#b8957e',
        colorLight: '#f3eadb'
      });
    },
    qrcode2 (link) {
      generateQRCode(document.getElementById('qrcode2'), {
        text: link,
        colorDark: '#b8957e',
        colorLight: '#f3eadb'
      });
    },
    // 分享图片设置
    generateShareImage () {      
      generateCanvasImage(this.$refs.imageDom)
        .then((canvas) => {
          this.preventShow = false;
          this.shareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
          console.log('success: 图片生成成功');
          this.shareShow = true;
          Indicator.close();
        })
        .catch((err) => {
          this.preventShow = false;
          Indicator.close();  
          console.log('err: 图片生成失败', err.message);
        });
    },
    // 复制链接
    onCopy () {
      this.logger.sum('小樱_百抽H5_点击弹窗中的复制按钮');
      const clipboard = new Clipboard('#clipboard-btn');
      clipboard.on('success', (e) => {
        this.onToast('复制成功');
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        this.onToast('复制失败');
      });
      this.logger.sum('copy_link');      
    },
    // swiper轮播
    mySwiper () {
      this.establishSuccessShow = false;
      this.$refs.mySwiper.init();
    },
    // swiper 翻下一页
    nextPage () {
      if (this.isUserInfo.account === undefined || this.isUserInfo.account === '') {
        this.changeLoginPopup(true);
      } else {
        if(this.isActivity.count == 0) {
          this.establishShow = true;
          
        } else {
          this.$refs.mySwiper.nextSwiper(1);
          this.noSwiperClass = '';
        }
      }
    },
    goNextPage () {
      this.establishSuccessShow = false;
      this.$refs.mySwiper.nextSwiper(1);
      this.noSwiperClass = '';
    },
    // 创立小队弹窗
    establishReturn(response) {
      const { code } = response || {}
      if (Number(code) === 200) {
        this.establishSuccessShow = true;
        // 创建后，初始化最新数据
        onGetInitDataAPI().then(response => {
          this.onInitDataCallback(response);
        });
      }
      if (Number(code) === 403) {
        this.changeLoginPopup(true);
      }
      if (Number(code) === 406) {
        onGetInitDataAPI().then(response => {
          this.onInitDataCallback(response);
        });
      }
    },
    // 选择角色后
    selectCallback () {
      onTeamBindApi().then(response => {
        const { code } = response || {}
        if (Number(code) === 200) {
          this.onToast('绑定成功');
          // 创建后，初始化最新数据
          onGetInitDataAPI().then(response => {
            this.onInitDataCallback(response);
          });
        } else {
          this.onToast(response.message);
        }
      });
      
    },
    // 区组弹窗注销-相关参数复位
    osCancell () {
      this.clearData();
    },
    // TAG: 相关业务方法
    onInvite () {
      if (this.isUserInfo.account === undefined || this.isUserInfo.account === '') {
        this.changeLoginPopup(true);
        return false;
      }
      this.shareShow = true;
    },
    closeShare () {
      this.shareShow = false;
    },
    // 埋点记录
    loggerCount(info) {
      this.logger.sum(info);
      setTimeout(() => {
        window.location = this.downloadUrl;
      }, 250);
    },
    // 微信分享
    isSetShare(linkUrl) {
      this.setShare({
        link: linkUrl + `${getTimeStamp()}`,
        title: '来魔卡少女樱手游，一同坠入梦境吧',
        imgUrl:
          'https://download4.qcplay.com/qcgame-admin/yTzSgoBsGBKICdfLlnUcy1pnfgNagaeLl3bcvtgP.png',
        desc: '和伙伴们组队游历，即可解锁百抽福利！',
      })
    },
    // 数据清除
    clearData() {
      this.isActivity.count = '';
      this.isActivity.is_create = '';
      this.isActivity.is_first = '';
      this.isActivity.is_join = '';
      this.isActivity.reward_list = '';      
      this.isActivity.user_id = 0;
      this.isActivity.team_data = [
        {nick_name : 0},
        {nick_name : 0},
        {nick_name : 0}
      ];      
      this.isUserInfo.account = '';
      this.isUserInfo.game_id = '';
      this.isUserInfo.role_id = '';
      this.isUserInfo.role_name = '';
      this.isUserInfo.server_id = '';
      this.isUserInfo.server_name = '';
      this.accountId = '';
      this.clipInfo = '';
      this.progress = 0;
      this.$refs.mySwiper.nextSwiper(0);
      this.logoutShow = false;
      this.headerLogin = false;
      this.noSwiperClass = 'swiper-no-swiping';
    },
    // TAG: 其他简易封装的方法
    onToast (config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    ...mapMutations([
      'changeLoginPopup',
      'changeOsPopup',
      'setInitActiveInfo',
      'setInitUserInfo',
      'setLogger'
    ]),
    ...mapActions([
      'onInitDataCallback',
      'onCount',
      'setShare'
    ])

  }
};
</script>

<style lang='less' scoped>
  @import url('./index.less');
</style>



// WEBPACK FOOTER //
// src/pages/sakura/lottery/index/index.vue